// Style Shot (이미지) 관련 타입들
export interface StyleShotItem {
  id: string
  type: 'style-shot'
  imageUrl: string
  status: 'queued' | 'processing' | 'completed' | 'failed'
  createdAt: string
  downloadUrl: string
  jobId: number
  requestId: number
  // 추가 style-shot 전용 필드들
  avatarId: number
  avatarName: string
  avatarThumbnailUrl: string
  backgroundId: number
  backgroundImageUrl: string
  backgroundName: string
  poseId: number
  poseName: string
}

// Style Clip (비디오) 관련 타입들
export interface StyleClipItem {
  id: string
  type: 'style-clip'
  imageUrl: string // thumbnailUrl과 동일
  videoUrl: string
  thumbnailUrl: string
  status: 'queued' | 'processing' | 'completed' | 'failed'
  createdAt: string
  downloadUrl: string
  // 추가 style-clip 전용 필드들
  videoPrompt: string
  pointCost: number
  sourceImageCount: number
  synthesizedImageUrls: string[]
  processingStartedAt: string
  completedAt: string
  errorMessage: string
}

// 통합 갤러리 아이템 (유니온 타입)
export type GalleryItem = StyleShotItem | StyleClipItem

export type GalleryTabType = 'style-shot' | 'style-clip'

// 각 타입별 데이터 구조
export interface StyleShotData {
  items: StyleShotItem[]
  totalCount: number
  totalPages: number
}

export interface StyleClipData {
  items: StyleClipItem[]
  totalCount: number
  totalPages: number
}

// 통합 갤러리 데이터 (기존 호환성 유지)
export interface GalleryData {
  items: GalleryItem[]
  totalCount: number
  totalPages: number
}

// 타입 가드 함수들
export const isStyleShotItem = (item: GalleryItem): item is StyleShotItem => {
  return item.type === 'style-shot'
}

export const isStyleClipItem = (item: GalleryItem): item is StyleClipItem => {
  return item.type === 'style-clip'
}

// Image API Response Types
export interface ImageAPIResponse {
  items: ImageRequestItem[]
  total: number
  page: number
  limit: number
  totalPages: number
}

export interface ImageRequestItem {
  avatarId: number
  avatarName: string
  avatarThumbnailUrl: string
  backgroundId: number
  backgroundImageUrl: string
  backgroundName: string
  completedAt: string
  jobId: number
  jobStatus: string
  poseId: number
  poseName: string
  requestCreatedAt: string
  requestId: number
  requestStatus: string
  resultUrl: string
}

export interface CompletedImage {
  jobId: number
  backgroundId: number
  backgroundName: string
  backgroundImageUrl: string
  poseId: number
  poseName: string
  resultUrl: string
  completedAt: string
}

// Video API Response Types
export interface VideoAPIResponse {
  items: VideoItem[]
  total: number
  page: number
  limit: number
  totalPages: number
}

export interface VideoItem {
  id: number
  status: string
  resultVideoUrl: string
  videoPrompt: string
  pointCost: number
  sourceImageCount: number
  synthesizedImageUrls: string[]
  thumbnailUrl: string
  createdAt: string
  processingStartedAt: string
  completedAt: string
  errorMessage: string
}
